import React from 'react';
import { GenPage } from '../components/Common/GenPage';
import { useT } from '../utils/i18n';

export const CrimeStory = () => {
  const t = useT();
  return (
    <GenPage
      title={t('page.crimeStory.title')}
      contentType="crimeStory"
      description={t('page.crimeStory.desc')}
      outputLabel={t('page.crimeStory.output')}
      showDurationSelector
      programMode
    />
  );
};
